import React from 'react'

import type { ButtonProps } from '../Button'
import { Button } from '../Button'

import styles from './index.module.css'

type Props = {
  children?: React.ReactNode
  onClose: () => void
  prevButtonProps: ButtonProps
  nextButtonProps: ButtonProps
}

export const Dialog: React.FC<Props> = ({
  children,
  onClose,
  prevButtonProps,
  nextButtonProps,
}) => (
  <div className={styles.overlay} onClick={onClose}>
    <div className={styles.dialog} onClick={(e) => e.stopPropagation()}>
      {children && <div className={styles.contentArea}>{children}</div>}
      <div className={styles.buttons}>
        <Button {...prevButtonProps} />
        <Button {...nextButtonProps} />
      </div>
    </div>
  </div>
)
